import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import { Md5 } from "md5-typescript";
import { WebApiCalls } from '../../webApiCalls/webApiCalls';
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {
	UpdateCartCount,
	UpdateCartAmount
} from "../../redux/actions/postActions";
import { validateContactNo } from '../../common/validation';
import { KMTracking } from '../../components/Tracking/KMTracking';

function SignUp(props) {
	const [mobile, setmobile] = useState('')
	const [show_mobile_error, setShowMobileError] = useState(false)
	const [mobile_error, setMobileError] = useState('')
	const [is_loading, setIsLoading] = useState(false)

	useEffect(() => {
        const listener = event => {
          if (event.code === "Enter" || event.code === "NumpadEnter") {
            event.preventDefault();
			preJoinPhoneInput(mobile) 
          }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      }, [mobile]);

	const tracker = async (eventName, _kmprops) => {
		await KMTracking(eventName, _kmprops)
	}
	const preJoinPhoneInput = (contact) => {
		setIsLoading(true)
		if (contact.trim() == '') {
			setShowMobileError(true)
			setMobileError('Please provide a phone number')
			setIsLoading(false)

			return
		}
		if(show_mobile_error){
			setIsLoading(false)
			return
		}
		let c = contact + "@phonenumber.com" + contact + "#frasers"
		let checksum = Md5.init(c)
		new WebApiCalls().PreJoinSignup(contact, checksum).then(response => {
			if (response?.data) {
				let eventData = {
					contact: contact,
					step: 'Registered Mobile',
					'Current Page': 'Registration Mobile',
					'Source Page': props?.location?.state?.from ? props?.location?.state?.from : ''
				}
				tracker("pageViewed", eventData)
				tracker("sign_up", eventData)
				props?.history?.push("/verify-otp", {
					verification_code: response.data.verification_code,
					mobile,
					from:'signup'
				})
				setIsLoading(false)

			} else if (!response?.data && response.error) {
				setShowMobileError(true)
				setMobileError(response.error)
				setIsLoading(false)

			}
		}).catch((error) => {
			console.log('Error catch: ', error)
			setIsLoading(false)

		})
	}
	const handleMobileChange = (event) => {
		if(event.target.value == ''){
			setShowMobileError(false)
		}
		setShowMobileError(false)
		setmobile(event.target.value)
		let valid = validateContactNo(event.target.value);
		if(!valid){
			setMobileError('This does not look like a valid mobile number')
		}
		setShowMobileError(!valid)
	}
	const ErrorView = (_text) => {
		return (<div className="error" style={{ display: "block", marginTop: 10 }}>{_text}</div>)
	}
	return (
		<div>
			<div className="viewport"></div>

			{/* /container */}
			<div className="container">

				{/* header */}
				<Header props={props} />
				{/* /header */}

    

				<MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>

				{/* login */}
				<div className="login">
					<div className="title">Join Frasers Experience</div>

					<form name="signup">

						<fieldset>
							<label htmlFor="">MOBILE NO.</label>
							<input type="text" pattern="[0-9]{8}" name="mobileno" id="mobileno" value={mobile} onChange={handleMobileChange} />
							{
								show_mobile_error &&
								ErrorView(mobile_error)
							}
						</fieldset>
						<div className="loadingBlackButton"
							onClick={(event) => {
								event.preventDefault()
								preJoinPhoneInput(mobile)
							}}
						>
							{
								is_loading ?
									<Loader
										type="TailSpin"
										color="white"
										height={18}
										width={18}
									/>
									:
									"NEXT"}
						</div>

					</form>

					<div className="greynote">
						A one-time password (OTP) will be sent via SMS to this mobile no. for verification.
						<br /><br />
						If you experience any difficulties verifying your account, please <a target='_blank' href="mailto:help@frasersestore.com">contact us</a> for assistance.
					</div>

					<div className="join">
						Already have a Frasers Experience account?
						<a onClick={() => {
							props?.history?.push("/login",{from:'Signup'})
						}}
						>{" Sign In"}</a>
					</div>

				</div>
				{/* /login */}

			</div>
			{/* /container */}

			<Footer categoriesArray={props?.allCategories ? props?.allCategories : []} />


		</div>
	)
}
const mapStateToProps = (state) => {
	const { cart_count,allCategories } = state.UserReducer
	return { cart_count,allCategories }
};
const actions = {
	UpdateCartCount,
	UpdateCartAmount
};
export default connect(mapStateToProps, actions)(SignUp);